import type { SVGProps } from 'react';

interface ImagePlaceholderIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ImagePlaceholderIcon({ className, ...props }: ImagePlaceholderIconProps) {
  return (
    <svg
      width="48"
      height="39"
      viewBox="0 0 48 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <rect x="47.5" y="0.500002" width="37.4" height="47" rx="2" transform="rotate(90 47.5 0.500002)" fill="#FFFCF7" stroke="#9A9691" />
      <path d="M15.9572 10.9717C15.957 12.2102 14.9526 13.2139 13.714 13.2139C12.4755 13.2137 11.472 12.2101 11.4718 10.9717C11.4718 9.73309 12.4754 8.72868 13.714 8.72852C14.9527 8.72852 15.9572 9.73299 15.9572 10.9717Z" fill="#E0DCD7" stroke="#9A9691" />
      <path d="M8.69727 19.1421C9.08085 18.7861 9.67399 18.7862 10.0576 19.1421L30.2695 37.8999H2.5C1.39543 37.8999 0.500002 37.0045 0.500002 35.8999V26.7485L8.69727 19.1421Z" fill="#E0DCD7" stroke="#9A9691" />
      <path d="M35.2207 8.60694C35.9548 7.97242 37.0384 7.95629 37.791 8.56885L46.7627 15.8716C47.2293 16.2514 47.5 16.8217 47.5 17.4233V35.8999C47.4999 37.0044 46.6045 37.8999 45.5 37.8999H2.68555C2.2225 37.8999 2.00834 37.3249 2.3584 37.022L35.2207 8.60694Z" fill="#EAE6E1" stroke="#9A9691" />
    </svg>
  );
}
